import KeyFiguresLineChartBox from './KeyFiguresLineChartBox'

export default KeyFiguresLineChartBox
